module.exports = __webpack_public_path__ + "static/media/warden_sword.b5c7cfc6.png";